import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(
      window.location.hash.replace(/^#/, "")
    ).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setToken(data.session_token);
        setUser(data);
        const home = data.role === "admin" ? "/admin" : "/trade";
        window.history.replaceState(null, "", home);
        navigate(home, { replace: true, state: { user: data } });
      } catch (e) {
        // Never bounce silently to the marketing page: the reason (not invited, revoked,
        // expired session id) is the only way to tell why sign-in failed.
        window.history.replaceState(null, "", "/login");
        setError(errMsg(e));
      }
    })();
  }, [navigate, setUser]);

  if (!error)
    return <div className="min-h-screen bg-[#08090A]" data-testid="auth-callback" />;

  return (
    <div
      className="min-h-screen bg-[#08090A] text-zinc-100 flex flex-col items-center justify-center px-6"
      data-testid="auth-callback-error"
    >
      <Logo size={28} />
      <p className="mt-8 text-xs tracking-[0.2em] uppercase font-semibold text-red-400">
        Sign-in failed
      </p>
      <p
        className="mt-3 max-w-md text-center text-sm text-zinc-300 leading-relaxed"
        data-testid="auth-error-message"
      >
        {error}
      </p>
      <button
        data-testid="auth-retry-btn"
        onClick={() => {
          window.location.href = "/login";
        }}
        className="mt-8 rounded-sm bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 text-sm font-semibold tracking-wide transition-colors duration-200 active:scale-95"
      >
        Try again
      </button>
    </div>
  );
}
